module.exports = __webpack_public_path__ + "media/images/front/pc/covid19/banner_header-e1f147091cd6943eaae66d38888d8bad.png";